module.exports = __webpack_public_path__ + "static/bleach-9dcfa0f52054c31d46218b32586c0054.jpg";